import i18next from 'i18next'

i18next.addResources('es', 'adminNavbar', {
  signOut: 'Salir',
  userMode: 'Modo usuario',
  logo: 'Logo-sura'
})
